import { Component, OnInit, AfterViewInit, NgZone, Inject, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Http } from '@angular/http';
import { DxFormComponent, DxButtonComponent, DxTextBoxComponent, DxSelectBoxComponent } from 'devextreme-angular';
import ValidationEngine from 'devextreme/ui/validation_engine';

import { Registration } from '../Services/Registration';
import { LanguageService } from '../Services/LanguageService';

@Component({
        styles: [`
    @media all and (min-width: 540px) {
        .formcontainer {
            width: 75%;
        }
    }

    .logo {
        margin-left: auto;
        margin-right: auto;
        display: block;
        height: 45px;
    }

    .confirmation-text {
        color: #333333;
        font-family: Arial;
        font-size: 18px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 21px;
        text-align: center;
        padding: 0 0 16px 0;
    }

    .confirmation-description {
        color: #333333;
        font-family: Arial;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 18px;
        text-align: center;
    }

    .right-link {
        margin-left: auto;
        text-align: right;
    }

    .links {
        display: flex;
        flex-direction: row;
        color: #009FDE;
        font-family: Arial;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 24px;
        margin-top: 24px;
    }

    .link {
        text-decoration: none;
        color: #009FDE;
    }

    .box {
        background-color: #FFFFFF;
        width: 500px;
        height: auto;
        margin: 0 auto;
        padding: 24px;
        margin-top: 48px;
    }

    .policy {
        text-align: center;
        padding-top: 16px;
    }

    .container{
        height: 100%;
        width: 100%;
        background-color: #F4FAFC;
        display: flex;
    }

    .policy-link {
        color: #003952;
        font-family: Arial;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 24px;
        text-align: center;
        text-decoration: none;
    }

    .errortext {
        color: red;
    }

    .i-agree{
        color: #333333;
        font-family: Arial;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
    }

    .link-bold{
        font-weight: bold;
    }

    .link-btn{
        color: #FFFFFF;
        font-family: Arial;
        font-size: 21px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 24px;
        text-align: center;
        background-color: #00A698;
    }

    .link-btn:hover {
        background-color: #079488 !important;
    }

    .external-panel{
        padding-top: 60px;
        margin: 0 auto;
    }


.standard-text-color {
    color: #333333;
}

.link-text-color {
    color: #009fde;
}

.ToS-text-color {
    color: #003952;
}

.sign-in-button {
    background-color: #00A698;
    color: #fff;
}

#light-mode {
    display: block;
}

#dark-mode {
    display: none;
}

.language {
    background-color: #F4FAFC !important;
}

@media (prefers-color-scheme: dark) {
    .standard-text-color {
        color: #E6E6E6;
    }

    .i-agree {
        color: #E6E6E6;
    }

    .language {
        background-color: #2A2A2A !important;
    }

    .box{
        background-color: #333333;
    }

    .ToS-text-color {
        color: #1CA8DD;
    }

    .link-text-color {
        color: #1CA8DD;
    }

    .container {
        background-color: #2A2A2A;
    }

    .sign-in-button {
        background-color: #1CA8DD;
        border: 0 !important;
    }

    ::ng-deep.dx-texteditor {
        background-color: #2A2A2A !important;
        border: 1px solid #454545 !important;
    }

    ::ng-deep .dx-field-item-label-text {
        color: #E6E6E6 !important;
    }

    ::ng-deep .dx-texteditor-input{
        color: #E6E6E6;
    }

    #light-mode {
        display: none !important;
    }

    #dark-mode {
        display: block !important;
    }
}
    /* for mobile*/
    @media (max-width: 768px) {

        .box{
            width: calc( 100% - 48px);
        }
    }
`],
template: `
    <div class="container">
        <div class="external-panel">
            <img id="light-mode" class="logo" src="/identity/content/icons/XMPro-Logo2x.png" />
            <img id="dark-mode" class="logo" src="/identity/content/icons/XMPro-White.png" />
            <div class="box">
                <p class="confirmation-text standard-text-color">Link your account</p>
                <div>
                    <div class="errortext" *ngIf="errorMessage && loadIndicatorVisible == false">{{errorMessage}}</div>
                    <dx-form [readOnly]="false"
                            [showRequiredMark]="true"
                            [showColonAfterLabel]="false"
                            labelLocation="top"
                            [minColWidth]="300"
                            [colCount]="1"
                            (onContentReady)="formReady($event)">
                        <dxi-item [label]="{ text: 'First Name' }"
                            dataField="Firstname">
                            <dxi-validation-rule type="required"></dxi-validation-rule>
                        </dxi-item>
                        <dxi-item [label]="{ text: 'Last Name' }"
                            dataField="Lastname">
                            <dxi-validation-rule type="required"></dxi-validation-rule>
                        </dxi-item>

                        <dxi-item dataField="Email"
                            [label]="{ text: 'Work Email' }">
                            <dxi-validation-rule type="required"></dxi-validation-rule>
                            <dxi-validation-rule type="email"></dxi-validation-rule>
                        </dxi-item>
                        <dxi-item dataField="Company"
                            [visible]="preDefinedCompany === undefined"
                            template="companyTemplate">
                        </dxi-item>
                        <div *dxTemplate="let data of 'companyTemplate'">
                            <dx-text-box [readOnly]="preDefinedCompany ? true : false"
                                [disabled]="singleTenantCompany ? true : false"
                                [(value)]="data.component.option('formData')[data.dataField]"
                                (onValueChanged)="this.validateAccount($event)">
                                <dx-validator validationGroup="Account">
                                    <dxi-validation-rule type="required"></dxi-validation-rule>
                                    <dxi-validation-rule type="custom" [reevaluate]="true" [validationCallback]="this.validateCompany" message="A company with this name is not registered, please confirm the company name with Administrator or create a new company if you are an administrator."></dxi-validation-rule>
                                    <dxi-validation-rule type="pattern" [pattern]="companyPattern" message="The name provided contains characters that are not valid. Please make sure that it doesn't contain special characters or spaces"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                        <dxi-item itemType="empty">
                        </dxi-item>
                    </dx-form>
                    <p class="i-agree" style="padding: 0 0 24px 0;"> By clicking below, you are agreeing to the XMPro <a class="link-bold" href="https://xmpro.com/terms-of-service" target="_blank" rel="noopener noreferrer">Cloud Terms of Service</a> and <a class="link-bold" href="https://xmpro.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></p>
                    <dx-button class="link-btn sign-in-button" text="Link Account" (onClick)="onSubmit($event)" width="100%" [height]="46" [disabled]="loadIndicatorVisible">
                        <div *dxTemplate="let data of 'content'">
                            <dx-load-indicator class='button-indicator' height="20" width="20" style='position:absolute; margin-top: 2px; margin-left: 20px;'
                                [visible]="loadIndicatorVisible">
                            </dx-load-indicator>
                            <div class='dx-button-text' style='margin-left: auto;'>{{data.text}}</div>
                        </div>
                    </dx-button>
                </div>
                <div class="links">
                    <div>
                        <a class="link link-text-color" href="../../">Sign in</a>
                    </div>
                    <div class="right-link">
                        <a class="link link-text-color" href="../Register">Sign up for an account</a>
                    </div>
                </div>
            </div>
            <p class="policy">
                <a class="policy-link link-text-color" href="https://xmpro.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                <span class="dot" style="margin: auto 0;"> • </span>
                <a class="policy-link link-text-color" href="https://xmpro.com/privacy-policy/" target="_blank" rel="noopener noreferrer">Terms of Service</a>
            </p>
        </div>
    </div>
    `,
    providers: [Registration, LanguageService]
})
export class RegisterExternal implements AfterViewInit {
    @ViewChild(DxFormComponent) form: DxFormComponent;
    @ViewChild(DxButtonComponent) submitBtn: DxButtonComponent;

    maskRules: any = { "X": /[02-9]/ };
    errorMessage: string = null;
    loadIndicatorVisible: boolean = false;
    singleTenantCompany: string | undefined;
    isSingleTenantCompany: boolean = false;
    companyPattern: RegExp = /^[a-zA-Z0-9_-]*$/;

    public get preDefinedCompany(): string {
        if (this.singleTenantCompany !== undefined)
            return this.singleTenantCompany;
        return this._route.snapshot.queryParams['company'];
    }

    public get trialProductId() {
        return this._route.snapshot.queryParams['trialProductId'];
    }

    constructor(private _registrationService: Registration,
        private _languageService: LanguageService,
        private _router: Router,
        private _route: ActivatedRoute,
        private zone: NgZone,
        private _http: Http) {
    }

    ngAfterViewInit() {
        this._registrationService.createExternalRegistrationRequest()
            .subscribe(res => {
                if (res && res.Status === false) {
                    this.errorMessage = res.Message;
                    return;
                }
                if (res.Firstname) {
                    let editor = this.form.instance.getEditor("Firstname") as any;
                    editor.option("value", res.Firstname);
                    editor.option("readOnly", true);
                }
                if (res.Lastname) {
                    let editor = this.form.instance.getEditor("Lastname") as any;
                    editor.option("value", res.Lastname);
                    editor.option("readOnly", true);
                }
                if (res.Email) {
                    let editor = this.form.instance.getEditor("Email") as any;
                    editor.option("value", res.Email);
                    editor.option("readOnly", true);
                }
                if (res.Company !== undefined && res.Company !== null && res.Company !== "") {
                    this.singleTenantCompany = res.Company;
                    this.isSingleTenantCompany = res.IsSingleTenantCompany;
                }
                //if (res.Country) {
                //    let editor = this.form.instance.getEditor("Country") as any;
                //editor.option("value", res.Country);
                //editor.option("readOnly", true);
                //}
                //if (res.Language) {
                //    let editor = this.form.instance.getEditor("Language") as any;
                //editor.option("value", res.Language);
                //editor.option("readOnly", true);
                //}
            }, error => {
                this.errorMessage = error._body;
            });
    }

    //validations
    validateCompanyComplete: boolean = true;
    validateCompany = (params: any) => {
        if (this.validateCompanyComplete == false) {
            this._registrationService.verifyCompany(params.value)
                .subscribe(res => {
                    this.validateCompanyComplete = true;
                    let checkbox = this.form.instance.getEditor("NewCompany") as any;
                    if (res == false) {
                        if (checkbox !== undefined && checkbox.option("value"))
                            params.rule.isValid = true;
                        else {
                            params.rule.message = params.value + " is not registered, please confirm the company name with Administrator or create a new company if you are an administrator.";
                            params.rule.isValid = false;
                            if (checkbox !== undefined) {
                                checkbox.option("visible", true);
                            }
                        }
                    }
                    else {
                        params.rule.isValid = true;
                        if (checkbox !== undefined) {
                            checkbox.option("value", false);
                            checkbox.option("visible", false);
                        }
                    }
                    params.validator.validate();
                }, error => {
                    params.rule.message = "Could not verify the Company name: " + error._body;
                    params.rule.isValid = false;
                    params.validator.validate();
                    return params.rule.isValid;
                });
        }
        return params.rule.isValid;
    }

    //events
    formReady = (e) => {
        //this._languageService.Initialize().then(() => {
        //    let countrySelectBox = e.component.getEditor("Country") as any;
        //    countrySelectBox.option("dataSource", this._languageService.Countries());
        //}, er => { this.errorMessage = "There were errors loading the form. Please make sure you are connected to the Internet and try again.";; });

        if (this.preDefinedCompany) {
            this.validateAccount(null);
        }
    }

    validateAccount = (e) => {
        this.validateCompanyComplete
            = false;
        ValidationEngine.validateGroup("Account");
    }

    //countrySelected = (e) => {
    //    let timezoneSelectBox = this.form.instance.getEditor("TimezoneName") as any;
    //    let languageSelectBox = this.form.instance.getEditor("Language") as any;
    //    //let telephoneTextBox = this.form.instance.getEditor("Telephone") as any;
    //    //var mobileTextBox = this.form.instance.getEditor("Mobile") as any;

    //    let country = this._languageService.GetCountryData(e.value);
    //    timezoneSelectBox.option("dataSource", country.descriptiveZones);
    //    languageSelectBox.option("dataSource", country.languages);
    //    //telephoneTextBox.option("mask", "+" + country.callingCodes[0].replace("9", "\\9") + " (X00) 000-0009");
    //    //mobileTextBox.option("mask", "+" + country.callingCodes[0].replace("9", "\\9") + " (X00) 000-0009");
    //    //ValidationEngine.resetGroup("Mobile"); // mobile is not required
    //}

    onSubmit = (e) => {
        if (this.validateForm()) {
            this.loadIndicatorVisible = true;

            const data = this.formSubmitPayload();

            this._registrationService.submitExternalRegistrationRequest(data)
                .subscribe(res => {
                    if (res.Status == true) {
                        if (this.trialProductId) {
                            window.location.href = res.Message;
                        }
                        else {
                            this._http.get(res.Message).subscribe(done => {
                                this.zone.run(() => {
                                    this._router.navigate(['/Complete', { email: data.Email }], { relativeTo: this._route });
                                });
                            });
                        }
                    }
                    else {
                        this.errorMessage = res.Message;
                        this.loadIndicatorVisible = false;
                    }
                }, error => {
                    this.errorMessage = error._body;
                    this.loadIndicatorVisible = false;
                });
        }
    }

    private validateForm(): boolean {
        const formValidationResult = this.form.instance.validate();

        if (formValidationResult.isValid) {

            if (!this.isSingleTenantCompany)
                return ValidationEngine.validateGroup("Account").isValid;

            return this.singleTenantCompany !== undefined && this.singleTenantCompany !== null && this.singleTenantCompany !== ""
        }
    }

    private formSubmitPayload() {
        const data = this.form.instance.option("formData");

        if (this.singleTenantCompany !== undefined)
            data.Company = this.singleTenantCompany;

        data.trialProductId = this.trialProductId;
        data.Language = 'en';

        return data;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Register/RegisterExternal.ts